// extracted by mini-css-extract-plugin
module.exports = {"base":"InputText_base__1St9p","input":"InputText_input__-iFuB","icon":"InputText_icon__31EKO"};